export default "__VITE_ASSET__be12355f__"